import { type ChangeEvent } from 'react';
import { TextField } from '.';
import MuiAutocomplete from '@material-ui/lab/Autocomplete';
import _ from 'lodash';

export interface AutocompleteProps {
	label?: string;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	options: any[];
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	value?: any;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	onChange: (e: ChangeEvent<any>, values: any) => void;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	getOptionLabel: (option: any) => string;
}

export function Autocomplete({
	getOptionLabel,
	label,
	options,
	value,
	...rest
}: AutocompleteProps) {
	const _value = _.isObject(value) ? value : options.find((o) => o.id == value) || null;

	return (
		<MuiAutocomplete
			autoHighlight
			getOptionLabel={getOptionLabel}
			noOptionsText={'No hay opciones'}
			options={options}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label || ''}
					variant={'standard'}
				/>
			)}
			value={_value}
			{...rest}
		/>
	);
}
